import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../ui/checkbox';
import { cn } from '../../lib/utils';
import type { ApprovalScope } from '../../hooks/use-approval-scope';

interface ApprovalScopeToggleProps {
  scope: ApprovalScope;
  className?: string;
  /** Defaults to "Solo le mie approvazioni"; other pages pass their own wording. */
  label?: string;
}

/** Checkbox that switches a page between "my people" and everybody. */
export const ApprovalScopeToggle: React.FC<ApprovalScopeToggleProps> = ({ scope, className, label }) => {
  const { t } = useTranslation();
  const text = label ?? t('approvalScope.onlyMine', 'Solo le mie approvazioni');
  const count = scope.directReports.length;
  const countLabel =
    count === 1
      ? t('approvalScope.countOne', '1 utente collegato')
      : t('approvalScope.countOther', '{{count}} utenti collegati', { count });

  return (
    <label
      className={cn(
        'inline-flex h-9 cursor-pointer select-none items-center gap-2 rounded-md border bg-background px-3 text-sm',
        className,
      )}
      title={t('approvalScope.hint', 'Persone di cui sei l\'approvatore diretto')}
    >
      <Checkbox
        checked={scope.onlyMine}
        onCheckedChange={(value) => scope.setOnlyMine(value === true)}
        disabled={!scope.ready}
        aria-label={text}
      />
      <span className="font-medium">{text}</span>
      <span className="text-xs tabular-nums text-muted-foreground">{scope.ready ? countLabel : '…'}</span>
    </label>
  );
};
